import { useAuth } from "wasp/client/auth";
import { getUserMembership, useQuery } from "wasp/client/operations";
import { useLocationContext } from "../contexts/LocationContext";

/** Member = verified membership at the selected location (or platform admin); everyone else is a visitor. */
export function useLocationMembership() {
  const { data: user } = useAuth();
  const { selectedLocation } = useLocationContext();
  const enabled = !!selectedLocation?.id && !!user;
  const { data: membership, isLoading } = useQuery(
    getUserMembership,
    { locationId: selectedLocation?.id ?? "" },
    { enabled },
  );
  const isMember = !!user?.isAdmin || !!(membership as { isVerified?: boolean } | null)?.isVerified;
  return {
    isMember,
    isLoading: enabled && isLoading,
    membership,
    locationCode: selectedLocation?.locationCode ?? null,
  };
}
